import { getFallbackValueIfNull } from 'owa-options-core';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    ConfettiOptions,
} from 'owa-outlook-service-options';
import getStore from '../data/store/store';

export default function isConfettiEnabled(): boolean {
    return getFallbackValueIfNull(
        getStore().isEnabled,
        getOptionsForFeature<ConfettiOptions>(OwsOptionsFeatureType.Confetti).confettiEnabled
    );
}
